module.exports = __webpack_public_path__ + "img/small-color-logo.c043b684.svg";